import React from 'react';
import * as Styled from './ReferenceIndicator.styles';
import classNames from 'classnames';

export interface ReferenceIndicatorProps {
  count: number;
  type?: 'warning' | 'part-warning';
}

const ReferenceIndicator: React.FC<ReferenceIndicatorProps> = ({ count, type }) => {
  // if 1, show a single dot
  // if 2, show 2 dots
  // if more, show 2 dots and a PlusDot
  return (
    <Styled.Container>
      {count === 1 && (
        <Styled.Dot
          className={classNames({
            warning: type === 'warning' || type === 'part-warning',
          })}
        />
      )}
      {count === 2 && (
        <>
          <Styled.Dot
            className={classNames({
              warning: type === 'warning',
            })}
          />
          <Styled.Dot
            className={classNames({
              warning: type === 'part-warning' || type === 'warning',
            })}
          />
        </>
      )}
      {count > 2 && (
        <>
          <Styled.PlusDot />
          <Styled.Dot
            className={classNames({
              warning: type === 'warning',
            })}
          />
          <Styled.Dot
            className={classNames({
              warning: type === 'part-warning' || type === 'warning',
            })}
          />
        </>
      )}
    </Styled.Container>
  );
};

export default ReferenceIndicator;
